module.exports = __webpack_public_path__ + "hinted-Montserrat-ExtraLightItalic.a1e4714e42c0104dcf75.eot";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-ExtraLightItalic.eot
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-ExtraLightItalic.eot
// module chunks = 1